import React, {Component} from "react";
import {connect} from "react-redux";

import * as actions from "../../actions/serverActions";

import IncompatibleComponent from "../../components/scenes/Incompatible";

class Incompatible extends Component {
    render() {
        return (
            <IncompatibleComponent
                serverVersion={this.props.serverVersion}
                compatibleServer={this.props.compatibleServer}
                availableDatabase={this.props.availableDatabase}
                compatibleDatabase={this.props.compatibleDatabase}
                databaseList={this.props.databaseList}
                updateDatabaseList={this.props.updateDatabaseList}
                invalidDatabaseList={this.props.invalidDatabaseList}
                loading={this.props.loading}
                serverDisconnect={this.props.dispatchDisconnectServerAction}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        serverVersion: store.server.version,
        compatibleServer: store.server.compatible,
        availableDatabase: store.server.availableDatabase,
        compatibleDatabase: store.server.compatibleDatabase,
        databaseList: store.server.databaseList,
        updateDatabaseList: store.server.updateDatabaseList,
        invalidDatabaseList: store.server.invalidDatabaseList,
        loading: store.server.updatingDatabase
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchDisconnectServerAction: () => {
            dispatch(actions.serverDisconnect());
        }
    };
};

export default Incompatible = connect(mapStoreToProps, mapDispatchToProps)(Incompatible);
